import React, { useState, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import PageLoader from "./Common/pageloader";

import Navbar from "./Common/Navbar";
import Home from "./Pages/Home/Home";
import Footer from "./Common/Footer";
import Login from "./Common/Login";
import Register from "./Common/Register";
import Order from "./Pages/Orders/Order";
import Cart from "./Pages/Cart/Cart";
import Aqua from "./Pages/Aqua/Aqua";
import Dog from "./Pages/Dogs/Dog";
import Cats from "./Pages/Cats/Cats";
import Birds from "./Pages/Birds/Birds";
import Addresspage from "./Pages/Address/Address-page";
import ProductViewpage from "./Pages/Product/Productviewpage";
import Paymentoptiongoogle from "./Pages/payment/Paymentoptiongoogle";
import BottomBar from "./Common/Bottombar";
import WishlistPage from "./Common/Whishlist";
import Thankyou from "./Pages/Home/Thankyou";
import Placeorder from "./Pages/PlaceOrder/place-order";
import Checkout from "./Pages/PlaceOrder/Checkout";
import Check from "./Pages/payment/check";
import Personal from "./Pages/personal Information/Personal";
import Myorders from './Pages/Orders/Myorders';
import Layout from "./Layout";
import TermsConditions from "./Common/terms-condition";
import Privacy from "./Common/privacy";
import ReturnPolicy from "./Common/return";
import { Support } from "@mui/icons-material";
import Supports from "./Common/support";


function App() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 800);
    return () => clearTimeout(timer);
  }, [location]);
  return (
    <>
      {loading && <PageLoader />}
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/thankyou" element={<Thankyou />} />
        <Route path="/order" element={<Order />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/aqua" element={<Aqua />} />
        <Route path="/dogs" element={<Dog />} />
        <Route path="/cats" element={<Cats />} />
        <Route path="/birds" element={<Birds />} />
        <Route path="/addresspage" element={<Addresspage />} />
        <Route path="/productview" element={<ProductViewpage />} />
        <Route path="/paymentoptiongoogle" element={<Paymentoptiongoogle />} />
        <Route path="/wishlist" element={<WishlistPage />} />
        <Route path="/place-order" element={<Placeorder />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/check" element={<Check />} />
        <Route path="/personal-info" element={<Personal />} />
        <Route path="/myorders" element={<Myorders />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/privacy" element={< Privacy/>} />
        <Route path="/return" element={< ReturnPolicy/>} />
        <Route path="/support" element={<Supports/>} />



      </Routes>
      <BottomBar />
      <Footer />
    </>

  );
}

export default App;
